import {useQuery} from '@apollo/react-hooks';

import type {
    GetRelatedEntitiesSearchResults as GetRelatedEntitiesSearchResultsQuery,
    GetRelatedEntitiesSearchResultsVariables as GetRelatedEntitiesSearchResultsQueryVariables,
} from 'nutshell-graphql-types';

import GET_RELATED_ENTITIES_SEARCH_RESULTS from '../queries/get-related-entities-search-results.graphql';

export const useGetRelatedEntities = (
    query?: string | null
): {
    isLoading: boolean;
    relatedEntities: any[];
    refetch: () => Promise<any>;
    fetchMore: (searchTerm?: string | null | undefined) => Promise<any>;
} => {
    const {data, loading, refetch, fetchMore} = useQuery<
        GetRelatedEntitiesSearchResultsQuery,
        GetRelatedEntitiesSearchResultsQueryVariables
    >(GET_RELATED_ENTITIES_SEARCH_RESULTS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            query,
        },
        notifyOnNetworkStatusChange: true,
    });

    const search = data ? data.search : null;
    const quickResults = search ? search.quickResults : null;

    const relatedEntities = quickResults ? quickResults.topResults : [];

    return {
        relatedEntities: relatedEntities,
        isLoading: loading,
        refetch,
        fetchMore: (searchTerm?: string | null) => {
            return fetchMore({
                query: GET_RELATED_ENTITIES_SEARCH_RESULTS,
                variables: {
                    query: searchTerm,
                },
                // @ts-expect-error
                updateQuery: (previousResult, {fetchMoreResult}) => {
                    if (!fetchMoreResult || !previousResult) return;

                    return {
                        search: {
                            __typename: 'SearchResultItemConnection',
                            ...fetchMoreResult.search,
                        },
                    };
                },
            });
        },
    };
};
